const {
    NATIONAL_DOCUMENT,
    RESIDENT_DOCUMENT,
    PASSPORT_DOCUMENT,
    OTHER_DOCUMENT
} = require('../constants/documentGroups')

const {
    DOCUMENT_NIF,
    DOCUMENT_NIE,
    DOCUMENT_PASSPORT,
    DOCUMENT_OTHER
} = require('../constants/documentCodes')

const commonAlgorithm = value => {
    const dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
    const letterPosition = parseInt(value, 10) % 23;

    if (letterPosition >= 0 && value.replace(/0/gi, '').length > 1) {
        const letter = dni_letters.charAt(letterPosition);
        return letter === value.charAt(8) && value.length === 9;
    }

    return false
}

const isValidNationalAlgorith = value => {
    const fillDniZeros = value => {
        const nZeros = 9 - value.length;
        for (let i = 0; i < nZeros; i++) {
            value = '0' + value;
        }
        return value;
    }

    const dni = fillDniZeros(value)
    const valid = commonAlgorithm(dni)
    return valid
}

const isValidResidentAlgorith = value => {
    const validNIE = nie =>  {
        let nie_prefix = nie.charAt(0);
        switch (nie_prefix) {
            case 'X':
                nie_prefix = 0;
                break;
            case 'Y':
                nie_prefix = 1;
                break;
            case 'Z':
                nie_prefix = 2;
                break;
            default:
                return false;
        }

        return commonAlgorithm(nie_prefix + nie.substr(1));
    };

    return validNIE(value)
}

module.exports = {
    lengthId: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    lengthPassport: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    lengthResident: 9,
    patternId: "",
    patternPassport: "",
    patternResident: "",
    isValidNationalAlgorith,
    isValidPassportAlgorith: () => { return true },
    isValidResidentAlgorith,
    documentGroupMap: {
        [NATIONAL_DOCUMENT] : [DOCUMENT_NIF],
        [PASSPORT_DOCUMENT] : [DOCUMENT_PASSPORT],
        [RESIDENT_DOCUMENT] : [DOCUMENT_NIE],
        [OTHER_DOCUMENT] : [DOCUMENT_OTHER]
    }
}